export default class MultilingualStringExportMode {
	static CURRENT_LANGUAGE = 'CURRENT_LANGUAGE';
	static ALL_LANGUAGES_SHEET = 'ALL_LANGUAGES_SHEET';
	static ALL_LANGUAGES_COLUMNS = 'ALL_LANGUAGES_COLUMNS';
};
